import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getCompany, setORN } from "../../actions/auth";
import { createRequest, getForms, getRequest, deleteRequest } from '../../actions/index';

import PageList from './PageList';

function mapStateToProps(state) {
  return {
    language: state.common.language,
    formTypes: state.forms.types,
    forms: state.forms.forms,
    loaders: state.forms.loaders,
    user: state.forms.user,
    companies: state.forms.companies,
    orn: state.forms.orn,
  };
}

export const mapDispatchToProps  = {
  getCompany,
  createRequest,
  getRequest,
  deleteRequest,
  getForms,
  setORN
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(PageList);
